export default {
    items: {
        1 : [
            {value: 0, label: 'Для всех'},
            {value: 13574, label: 'Платежи через Евросеть'},
            {value: 13576, label: 'Банк Открытие'},
            {value: 13577, label: 'Банк МКБ - наличные'},
            {value: 13578, label: 'Банк МКБ - карты'},
            {value: 13579, label: 'Contact'},
            {value: 13584, label: 'Промсвязьбанк - наличные'},
            {value: 13585, label: 'Промсвязьбанк - банк-клиент'},
            {value: 13648, label: 'Интернет-эквайринг'},
            {value: 14971, label: 'QIWI'},
        ],
        2 : [
            {value: 0, label: 'Для всех'},
            {value: 2, label: 'Epos Оплата картами Visa и MasterCard'},
            {value: 100, label: 'Терминал PayTravel'}
        ],
      3 : [
        {value: 0, label: 'Для всех'},
        {value: 2, label: 'Интернет-эквайринг'},
        {value: 1, label: 'Система быстрых платежей. Оплата по QR коду'},
      ],
      5 : [
        {value: 0, label: 'Для всех'},
        {value: 2, label: 'Интернет-эквайринг'},
        {value: 1, label: 'Система быстрых платежей. Оплата по QR коду'},
      ],
      8 : [
        {value: 0, label: 'Для всех'},
        {value: 2, label: 'Интернет-эквайринг'},
        {value: 1, label: 'Система быстрых платежей. Оплата по QR коду'},
      ],
      9 : [
        {value: 0, label: 'Для всех'},
        {value: 2, label: 'Интернет-эквайринг'},
        {value: 1, label: 'Система быстрых платежей. Оплата по QR коду'},
      ],
      11 : [
        {value: 0, label: 'Для всех'},
        {value: 2, label: 'Интернет-эквайринг'},
        {value: 1, label: 'Система быстрых платежей. Оплата по QR коду'},
      ],
      14 : [
        {value: 0, label: 'Для всех'},
        {value: 2, label: 'Интернет-эквайринг'},
        {value: 1, label: 'Система быстрых платежей. Оплата по QR коду'},
      ],
    }
}
